import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './translate.js'

Vue.config.productionTip = true

// import bulmaTabBar from './components/bulma_tabbar.vue'
// Vue.component('bulmaTabBar', bulmaTabBar);

var myApp=new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.myApp=myApp;

import numeral from 'numeral'

if (numeral.locales['it'] === undefined) {
  numeral.register('locale', 'it', {
      delimiters: { thousands: '.', decimal: ',' },
      abbreviations: { thousand: 'k', million: 'm', billion: 'b', trillion: 't' },
      currency: { symbol: '€'}
  });
}

if (numeral.locales['us'] === undefined) {
  numeral.register('locale', 'us', {
      delimiters: { thousands: ',', decimal: '.' },
      abbreviations: { thousand: 'k', million: 'm', billion: 'b', trillion: 't' },
      currency: { symbol: '$'}
  });
}
